export const ACTIVITY_VALUE_ENDPOINTS = {
    type: 'v1/activity/values/activityType',
} as const
